import { Track } from 'src/@types/tracks';
import { InstructorType } from 'src/sections/dashboard/instructors/types';
import { Category } from './Category';
import { Package } from './package';

export enum CourseLevelsEnum {
  BASIC = 'basic',
  INTERMEDIATE = 'intermediate',
  ADVANCED = 'advanced',
  PROFESSIONAL = 'professional',
}
export enum ItemTypesEnum {
  TEXT = 'text',
  DOCUMENT = 'document',
  VIDEO = 'video',
  QUIZ = 'quiz',
  NEW=''

}

export enum QuestionTypesEnum {
  MCQ = 'mcq',
  COMPLETE = 'complete',
  trueFalse = 'trueFalse',
}
export type CourseCreate = {
  keywords: string[];
  keywords_ar?: string[];
  name: string;
  name_ar?: string;
  description: string;
  description_ar?: string;
  duration: number;
  briefVideo: string;
  certificateUrl: string;
  image: string;
  icon: string;
  category: string;
  track: string;
  instructor: string;
  active: boolean;
  level: CourseLevelsEnum;
  package: string;
  isFree: boolean;
  passScore?: number;
  slug?: string;
  order?: number;
  price?: number;
  price_usd?: number;
  seo_title?: string;
  seo_title_ar?: string;
  seo_description?: string;
  seo_description_ar?: string;
};
export type Course = {
  keywords: string[];
  keywords_ar?: string[];
  id: string;
  _id: string;
  name: string;
  name_ar?: string;
  description: string;
  description_ar?: string;
  duration: number;
  briefVideo: string;
  rating: number;
  icon?: string;
  image?: string;
  certificateUrl: string;
  category: Category;
  sections: Section[];
  track: Track;
  instructor: InstructorType;
  active: boolean;
  createdAt: string;
  updatedAt: string;
  package: Package;
  level: CourseLevelsEnum;
  isFree: boolean;
  passScore?: number;
  slug?: string;
  order?: number;
  price?: number;
  price_usd?: number;
  seo_title?: string;
  seo_title_ar?: string;
  seo_description?: string;
  seo_description_ar?: string;
};
export type Section = {
  title: string;
  title_ar?: string;

  description: string;
  description_ar?: string;

  order: number;

  items: Item[] | undefined;
};
export type Item = {
  uuid?: string;

  title: string;
  title_ar?: string;

  description?: string;
  description_ar?: string;

  order?: number;

  url?: string;
  assets?: string[];
  isFreeToWatch: boolean;
  duration: number;
  points?: number;

  details: VideoItem | DocumentItem | QuizItem | TextItem | undefined;
};
export interface VideoItem {
  type: ItemTypesEnum;
}
export interface DocumentItem {
  type: ItemTypesEnum;
}

export interface TextItem {
  body: string;
  body_ar?: string;
  type: ItemTypesEnum;
}

export interface MCQQuestion {
  title: string;
  title_ar?: string;
  description?: string;
  description_ar?: string;
  multi: boolean;
  answers: QuestionAnswer[];
  type: QuestionTypesEnum;
}

export type MCQQuestionDocument = MCQQuestion & Document;

export interface QuestionAnswer {
  name: string;

  points: number;

  // minusPoints: number;

  correct: boolean | undefined;
}

export type QuestionAnswerDocument = QuestionAnswer & Document;

export interface QuizItem {
  questions: MCQQuestion[] | undefined;
  type: ItemTypesEnum;
  // Max attempts a student gets for this quiz (instructor-set; default 3).
  attemptsLimit?: number;
  // Per-question time limit in seconds (0 = no per-question limit).
  secondsPerQuestion?: number;
  // Pass mark (%) for this quiz (default 50).
  passingScore?: number;
  // How many questions to serve per attempt (0 = all; for randomized subset).
  questionsToServe?: number;
}
